import React from 'react';
import MonoovaContainer from 'containers/monoova';

const Monoova: React.FC = () => {
  return <MonoovaContainer />;
};

export default Monoova;
